import { render, staticRenderFns } from "./AttachmentsContainer.vue?vue&type=template&id=60f978a1&"
import script from "./AttachmentsContainer.vue?vue&type=script&lang=js&"
export * from "./AttachmentsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports